export const ipAssistantKeys = {
    all: ['ip-assistant-settings'],
    settings: () => [...ipAssistantKeys.all, 'settings'],
    users: (query, page, sortBy, sortDir) => [...ipAssistantKeys.all, 'users', query, page, sortBy, sortDir],
    allowedUsers: (page, sortBy, sortDir) => [...ipAssistantKeys.all, 'allowed-users', page, sortBy, sortDir]
};
